import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import { FormField, FormSelect } from '@/_components';
import { defaultEmptyValueOption } from '@/_shared';

import { createMonthDaysOptions, monthOptions } from './schema';

const dayOptions = createMonthDaysOptions();

export function BirthdateInput({ isEditable = true, isCreate = false }: { isEditable?: boolean; isCreate?: boolean }) {
  const form = useFormContext();
  const [birth_month, birth_day] = form.watch(['birth_month', 'birth_day']);

  useEffect(() => {
    if (birth_month.value === '' && birth_day.value !== '') {
      form.setValue('birth_day', defaultEmptyValueOption(), { shouldDirty: false });
    }

    if (parseInt(birth_day.value || '0', 10) > birth_month.maxDays) {
      form.setValue('birth_day', defaultEmptyValueOption(), { shouldDirty: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [birth_month, birth_day]);

  return (
    <section
      className={`col-span-12 flex max-w-full gap-x-1 gap-y-8 sm:col-span-6 ${isCreate ? '' : '2xl:col-span-3'}`}
    >
      <div className="flex-1">
        <FormField
          control={form.control}
          name="birth_month"
          render={({ field: { value, onChange } }) => (
            <FormSelect
              disabled={!isEditable}
              value={value}
              getOptionLabel={(option) => option.name}
              onChange={onChange}
              options={monthOptions}
              label="Birthdate"
              isClearable={false}
              menuClassName="min-w-28"
            />
          )}
        />
      </div>

      <div className="shrink-0 grow-0">
        <FormField
          control={form.control}
          name="birth_day"
          render={({ field: { value, onChange } }) => (
            <FormSelect
              disabled={!isEditable || birth_month.value === ''}
              value={value}
              getOptionLabel={(option) => option.name}
              onChange={onChange}
              isClearable={false}
              options={dayOptions}
              label=""
            />
          )}
        />
      </div>
    </section>
  );
}
